module.exports = __webpack_public_path__ + "static/media/10.63b0a559.jpg";